import { fields, createSchema, validate as _validate } from '..';

import { roles } from './../../constants';

const { CLIENT, THERAPIST, ADMIN } = roles;

const {
  email,
  firstName,
  lastName,
  requiredText,
  phoneNumber,
  optionalPhoneNumber,
  organisationName,
  uniqueSlug,
} = fields;

const client = createSchema({
  email,
  firstName,
  lastName,
  mobileNumber: optionalPhoneNumber,
  contactNumber: phoneNumber,
});

const therapist = createSchema({
  email,
  firstName,
  lastName,
  bio: requiredText,
  contactEmail: email,
  contactNumber: phoneNumber,
});

const admin = createSchema({
  email,
  firstName,
  lastName,
  organisationName,
  uniqueSlug,
});

const validate = (data) => {
  if (data.role === CLIENT) return _validate(client, data);
  if (data.role === THERAPIST) return _validate(therapist, data);
  if (data.role === ADMIN) return _validate(admin, data);
};

export default validate;
